import React, { useState, useEffect, useRef, Suspense } from 'react'
import { Canvas, Dom, extend, useLoader, useThree, useFrame } from '@react-three/fiber'
import * as THREE from 'three';
import { useSpring, useSprings, a } from '@react-spring/three'
import InViewMonitor from 'react-inview-monitor';
import { useRoutes, A } from "hookrouter";
import { useSceneStore } from '../store'
import useScrollStore from '../store/scroll'

const ActivityPanel = ({
  setCursor,
  panelColor, //purple
  mainImage, //assets/images/drawdogs-600.gif
  mainUrl, ///game/drawdogs
  mainUrlTarget,  //_self
  imageHoverMsg, // optional word-balloon text when hovering the main image
  btnOneUrl, ///game/drawdogs
  btnOneUrlTarget = "_self", 
  btnOneMode = "play",
  btnOneMsg, //Follow along and Draw Your Own Dogs!
  btnTwoUrl, //  /fun/DrawYourOwnDogs_Worksheet.pdf
  btnTwoMsg,//Download the Draw Your Own Dogs activity sheet!
  btnTwoUrlTarget = "_self", 
  btnTwoMode = "print",
  btnTwoOnClick, // Custom click handler for btnTwo
  btnThreeUrl,
  btnThreeMsg,
  btnThreeUrlTarget = "_self", 
  btnThreeMode = "print",

  ...props }) => {

  const [cursor, setCursorState] = useState('default');
  const leaveClearTimerRef = useRef(null);
  const messages = useSceneStore((s) => s.messages)
  const mode = useSceneStore((s) => s.mode)
  const sectionActive = useScrollStore((s) => s.sectionActive)

  const clearLeaveTimer = () => {
    if (leaveClearTimerRef.current != null) {
      clearTimeout(leaveClearTimerRef.current);
      leaveClearTimerRef.current = null;
    }
  };

  const onBtnEnter = (msg) => {
    clearLeaveTimer();
    setCursor(msg, false);
  };

  /** Restore homepage section copy (or clear in grid) instead of leaving topic blank, which broke the balloon after scroll. */
  const onBtnLeave = (hoverMsg) => {
    clearLeaveTimer();
    leaveClearTimerRef.current = setTimeout(() => {
      leaveClearTimerRef.current = null;
      const currentTopic = useSceneStore.getState().topic
      if (currentTopic !== hoverMsg) {
        return
      }
      if (mode !== 'grid' && messages[sectionActive] != null) {
        setCursor(messages[sectionActive], true)
      } else {
        setCursor('', true)
      }
    }, 280);
  };

  useEffect(() => () => clearLeaveTimer(), []);

  return (
    <InViewMonitor
      classNameNotInView='content-holder'
      classNameInView={`content-holder colorize ${panelColor}`}
      toggleClassNameOnInView={true}
    >
      <div>
        <div
          className={`image-holder clickable${imageHoverMsg ? ' has-cursor-hover' : ''}`}
          onClick={() => window.open(mainUrl, mainUrlTarget)}
          {...(imageHoverMsg
            ? {
                'data-cursor-tooltip': true,
                onMouseEnter: () => onBtnEnter(imageHoverMsg),
                onMouseLeave: () => onBtnLeave(imageHoverMsg),
              }
            : {})}
        >
          <img src={mainImage} alt="" />
        </div>

        <div className="buttonContainer">
          <A 
            href={(btnOneUrl.includes("http") ? '#'  : btnOneUrl)}
            onClick={() => {
              if (btnOneUrl.includes("http")) {
                window.open(btnOneUrl, btnOneUrlTarget);
              }
            }}
          >
            <div 
              data-cursor-tooltip
              onMouseEnter={() => onBtnEnter(btnOneMsg)} 
              onMouseLeave={() => onBtnLeave(btnOneMsg)} 
              className={`roundButton ${btnOneMode}Btn`}
            />
          </A>
          {btnTwoUrl &&
            <A 
              href={(btnTwoUrl.includes("http") ? '#'  : btnTwoUrl)}
              onClick={() => {
                if (btnTwoOnClick) {
                  btnTwoOnClick();
                } else if (btnTwoUrl.includes("http")) {
                  window.open(btnTwoUrl, btnTwoUrlTarget);
                }
              }}
            >
              <div
                data-cursor-tooltip
                onMouseEnter={() => onBtnEnter(btnTwoMsg)} 
                onMouseLeave={() => onBtnLeave(btnTwoMsg)} 
                className={`roundButton ${btnTwoMode}Btn secondBtn`}
              />
            </A>
          }

          {btnThreeUrl &&
            <A 
              href={(btnThreeUrl.includes("http") ? '#'  : btnThreeUrl)}
              onClick={() => {
                if (btnThreeUrl.includes("http")) {
                  window.open(btnThreeUrl, btnThreeUrlTarget);
                }
              }}
            >
              <div
                data-cursor-tooltip
                onMouseEnter={() => onBtnEnter(btnThreeMsg)} 
                onMouseLeave={() => onBtnLeave(btnThreeMsg)} 
                className={`roundButton ${btnThreeMode}Btn thirdBtn playBtn2`}
              />
            </A>
          }
        </div>
      </div>
    </InViewMonitor>
  );
};

export default ActivityPanel;